import axios from 'axios';

export function getListCurrency(payload) {
    const options = {
        method: 'GET',
        url: process.env.REACT_APP_URL + '/api/common/getallcurrencies',
        withCredentials: true,
        headers: {
            'content-type': 'application/json',
            Authorization: 'Bearer ' + payload,
        }
    }
    return axios(options)
}



// WEBPACK FOOTER //
// ./src/utils/getListCurrency.js